import { baseUrl } from "../api/api"

export const getImageUrl = (url) => {
    return baseUrl + url;
}